(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[552],{

/***/ 2822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Uy": function() { return /* binding */ BlogSEO; },
  "TQ": function() { return /* binding */ PageSEO; }
});

// UNUSED EXPORTS: CommonSEO, TagSEO

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
;// CONCATENATED MODULE: ./constants/METADATA.ts
var METADATA_METADATA = {
  title: "Free CV Builder | Create a Professional CV Online",
  description: "Design a compelling CV with our free, easy-to-use online CV builder. No sign-up required. Start crafting your professional resume and land your dream job today!",
  siteUrl: "https://resumelio.com",
  image: "/assets/images/image.jpg",
  socialBanner: "/assets/images/image.jpg",
  siteLogo: "/assets/images/logo.png",
  author: {
    name: "Resumelio",
    minibio: "\n            Resumelio is a free online CV builder that helps you create a professional resume in minutes.\n        "
  }
};
/* harmony default export */ var constants_METADATA = (METADATA_METADATA);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/utilities/SEO.tsx






var CommonSEO = function CommonSEO(_ref) {
  var title = _ref.title,
      description = _ref.description,
      ogType = _ref.ogType,
      ogImage = _ref.ogImage,
      canonicalUrl = _ref.canonicalUrl;
  var router = (0,next_router.useRouter)();
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
      children: title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "robots",
      content: "follow, index"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      name: "description",
      content: description
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:url",
      content: "".concat(constants_METADATA.siteUrl).concat(router.asPath)
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:type",
      content: ogType
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:site_name",
      content: constants_METADATA.title
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:description",
      content: description
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:title",
      content: title
    }), Array.isArray(ogImage) ? ogImage.map(function (_ref2) {
      var url = _ref2.url;
      return /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: url
      }, url);
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
      property: "og:image",
      content: ogImage
    }, ogImage), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
      rel: "canonical",
      href: canonicalUrl ? canonicalUrl : "".concat(constants_METADATA.siteUrl).concat(router.asPath)
    })]
  });
};
var PageSEO = function PageSEO(_ref3) {
  var title = _ref3.title,
      description = _ref3.description;
  var ogImageUrl = constants_METADATA.siteUrl + constants_METADATA.socialBanner;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(CommonSEO, {
    title: title,
    description: description,
    ogType: "website",
    ogImage: ogImageUrl
  });
};
var TagSEO = function TagSEO(_ref4) {
  var title = _ref4.title,
      description = _ref4.description;
  var ogImageUrl = METADATA.siteUrl + METADATA.socialBanner;
  var router = useRouter();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(CommonSEO, {
      title: title,
      description: description,
      ogType: "website",
      ogImage: ogImageUrl
    }), /*#__PURE__*/_jsx(Head, {
      children: /*#__PURE__*/_jsx("link", {
        rel: "alternate",
        type: "application/rss+xml",
        title: "".concat(description, " - RSS feed"),
        href: "".concat(METADATA.siteUrl).concat(router.asPath, "/feed.xml")
      })
    })]
  });
};
var BlogSEO = function BlogSEO(_ref5) {
  var authorDetails = _ref5.authorDetails,
      title = _ref5.title,
      summary = _ref5.summary,
      date = _ref5.date,
      lastmod = _ref5.lastmod,
      url = _ref5.url,
      _ref5$images = _ref5.images,
      images = _ref5$images === void 0 ? [] : _ref5$images,
      canonicalUrl = _ref5.canonicalUrl;
  var publishedAt = new Date(date).toISOString();
  var modifiedAt = new Date(lastmod || date).toISOString();
  var imagesArr = images.length === 0 ? [constants_METADATA.socialBanner] : typeof images === 'string' ? [images] : images;
  var featuredImages = imagesArr.map(function (img) {
    return {
      '@type': 'ImageObject',
      // @ts-ignore
      url: img.includes('http') ? img : constants_METADATA.siteUrl + img
    };
  });
  var authorList;

  if (authorDetails) {
    authorList = authorDetails.map(function (author) {
      return {
        '@type': 'Person',
        name: author.name
      };
    });
  } else {
    authorList = {
      '@type': 'Person',
      name: constants_METADATA.author
    };
  }

  var structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': url
    },
    headline: title,
    image: featuredImages,
    datePublished: publishedAt,
    dateModified: modifiedAt,
    author: authorList,
    publisher: {
      '@type': 'Organization',
      name: constants_METADATA.author,
      logo: {
        '@type': 'ImageObject',
        url: "".concat(constants_METADATA.siteUrl).concat(constants_METADATA.siteLogo)
      }
    },
    description: summary
  };
  var twImageUrl = featuredImages[0].url;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CommonSEO, {
      title: title,
      description: summary,
      ogType: "article" // @ts-ignore
      ,
      ogImage: featuredImages,
      twImage: twImageUrl,
      canonicalUrl: canonicalUrl
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [date && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: publishedAt
      }), lastmod && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: modifiedAt
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
          __html: JSON.stringify(structuredData, null, 2)
        }
      })]
    })]
  });
};

/***/ }),

/***/ 7285:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AmpStateContext = void 0;

var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);

var _react = _interop_require_default(__webpack_require__(7294));

var AmpStateContext = _react["default"].createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ 354:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isInAmpMode = isInAmpMode;

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

/***/ }),

/***/ 6505:
/***/ (function(module, exports, __webpack_require__) {

"use client";
"use strict";

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaultHead = defaultHead;
exports["default"] = void 0;

var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);

var _interop_require_default = (__webpack_require__(2648)/* ["default"] */ .Z);

var _interop_require_wildcard = (__webpack_require__(1598)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(7294));

var _sideEffect = _interop_require_default(__webpack_require__(148));

var _ampContext = __webpack_require__(7285);

var _headManagerContext = __webpack_require__(523);

var _ampMode = __webpack_require__(354);

var _warnOnce = __webpack_require__(2783);

'use client';

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react["default"].createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react["default"].createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react["default"].Fragment) {
    return list.concat(_react["default"].Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
 returns a function for filtering head child elements
 which shouldn't be duplicated, like <title/>
 Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;
    var hasKey = false;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      hasKey = true;
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if ((metatype !== 'name' || !hasKey) && categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
 *
 * @param headChildrenElements List of children of <Head>
 */


function reduceComponents(headChildrenElements, props) {
  var inAmpMode = props.inAmpMode;
  return headChildrenElements.reduce(onlyReactElement, []).reverse().concat(defaultHead(inAmpMode).reverse()).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if ( true && !inAmpMode) {
      if (c.type === 'link' && c.props['href'] && // TODO(prateekbh@): Replace this with const from `constants` when the tree shaking works.
      ['https://fonts.googleapis.com/css', 'https://use.typekit.net/'].some(function (url) {
        return c.props['href'].startsWith(url);
      })) {
        var newProps = _extends({}, c.props || {});

        newProps['data-href'] = newProps['href'];
        newProps['href'] = undefined; // Add this attribute to make it easy to identify optimized tags

        newProps['data-optimized-fonts'] = true;
        return /*#__PURE__*/_react["default"].cloneElement(c, newProps);
      }
    }

    if (false) { var srcMessage; }

    return /*#__PURE__*/_react["default"].cloneElement(c, {
      key: key
    });
  });
}
/**
 * This component injects elements to `<head>` of your page.
 * To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
 */


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react).useContext(_ampContext.AmpStateContext);
  var headManager = (0, _react).useContext(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react["default"].createElement(_sideEffect["default"], {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _ampMode).isInAmpMode(ampState)
  }, children);
}

var _default = Head;
exports["default"] = _default;

if ((typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) && typeof exports["default"].__esModule === 'undefined') {
  Object.defineProperty(exports["default"], '__esModule', {
    value: true
  });
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 148:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = SideEffect;

var _interop_require_wildcard = (__webpack_require__(1598)/* ["default"] */ .Z);

var _react = _interop_require_wildcard(__webpack_require__(7294));

function SideEffect(props) {
  var headManager = props.headManager,
      reduceComponentsToState = props.reduceComponentsToState;

  function emitChange() {
    if (headManager && headManager.mountedInstances) {
      var headElements = _react.Children.toArray(Array.from(headManager.mountedInstances).filter(Boolean));

      headManager.updateHead(reduceComponentsToState(headElements, props));
    }
  }

  if (isServer) {
    var ref;
    headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref.add(props.children);
    emitChange();
  }

  useClientOnlyLayoutEffect(function () {
    var ref1;
    headManager == null ? void 0 : (ref1 = headManager.mountedInstances) == null ? void 0 : ref1.add(props.children);
    return function () {
      var ref;
      headManager == null ? void 0 : (ref = headManager.mountedInstances) == null ? void 0 : ref["delete"](props.children);
    };
  }); // We need to call `updateHead` method whenever the `SideEffect` is trigger in all
  // life-cycles: mount, update, unmount. However, if there are multiple `SideEffect`s
  // being rendered, we only trigger the method from the last one.
  // This is ensured by keeping the last unflushed `updateHead` in the `_pendingUpdate`
  // singleton in the layout effect pass, and actually trigger it in the effect pass.

  useClientOnlyLayoutEffect(function () {
    if (headManager) {
      headManager._pendingUpdate = emitChange;
    }

    return function () {
      if (headManager) {
        headManager._pendingUpdate = emitChange;
      }
    };
  });
  useClientOnlyEffect(function () {
    if (headManager && headManager._pendingUpdate) {
      headManager._pendingUpdate();

      headManager._pendingUpdate = null;
    }

    return function () {
      if (headManager && headManager._pendingUpdate) {
        headManager._pendingUpdate();

        headManager._pendingUpdate = null;
      }
    };
  });
  return null;
}

var isServer = false;
var useClientOnlyLayoutEffect = isServer ? function () {} : _react.useLayoutEffect;
var useClientOnlyEffect = isServer ? function () {} : _react.useEffect;

/***/ }),

/***/ 2783:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.warnOnce = void 0;

var warnOnce = function warnOnce(_) {};

if (false) { var warnings; }

exports.warnOnce = warnOnce;

/***/ }),

/***/ 4013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var _components_utilities_SEO__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2822);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4943);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9521);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5893);







var Container = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].section.withConfig */ .ZP.section.withConfig({
  displayName: "about-us__Container",
  componentId: "sc-1msmg22-0"
})(["padding:0 1rem;max-width:1400px;margin:auto;"]);

var Page = function Page() {
  var _useTranslation = (0,next_i18next__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)(["about-us", "common"]),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(_components_utilities_SEO__WEBPACK_IMPORTED_MODULE_1__/* .PageSEO */ .TQ, {
      title: t("about_us_meta_title"),
      description: t("about_us_meta_description")
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(Container, {
      className: "flex column gap-8",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("h1", {
        className: "h2",
        children: t("title")
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("p", {
        children: t("content")
      })]
    })]
  });
};

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Page);

/***/ }),

/***/ 4183:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us",
      function () {
        return __webpack_require__(4013);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(6505)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(4183); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);